import { restClient } from '@/Core'

import { CLIENT_LOSSES_REPORT_URL } from '../Contracts/IClientLossesReport'
import { reportSearchParams, toNumber, toPeriod, toRows } from '../Helpers/reportResponse'

import type { IClientLossesReport } from '../Contracts/IClientLossesReport'
import type { IReportPeriod } from '../Contracts/IReportPeriod'

const toCounts = (value: unknown): Record<string, number> =>
    Object.fromEntries(
        Object.entries(value !== null && typeof value === 'object' ? (value as Record<string, unknown>) : {}).map(
            ([key, count]) => [key, toNumber(count)]
        )
    )

/**
 * «Звіт по програним заявкам»: `GET /services/reports/client_losses`
 * (`SPEC-027` §3.3). Параметра сортування бек не має: рядки — «Заявки»
 * спадно (П-04), колонки сортує таблиця на місці (дані невеликі).
 */
export const LoadClientLossesReportTask = async (period: IReportPeriod): Promise<IClientLossesReport> => {
    const response = (await restClient.get(
        CLIENT_LOSSES_REPORT_URL,
        { searchParams: reportSearchParams(period) },
        { forceRefresh: true }
    )) as unknown as Record<string, unknown> | null

    const total = (response?.['total'] ?? {}) as Record<string, unknown>

    return {
        period: toPeriod(response?.['period'], period),
        reasons: toRows(response?.['reasons']).map((raw) => {
            const reason = (raw ?? {}) as Record<string, unknown>

            return {
                uuid: String(reason['uuid'] ?? ''),
                title: String(reason['title'] ?? ''),
                isRemoved: reason['isRemoved'] === true,
            }
        }),
        rows: toRows(response?.['rows']).map((raw) => {
            const row = (raw ?? {}) as Record<string, unknown>
            const client = (row['client'] ?? {}) as Record<string, unknown>

            return {
                client: { uuid: String(client['uuid'] ?? ''), title: String(client['title'] ?? '') },
                applications: toNumber(row['applications']),
                byReason: toCounts(row['byReason']),
            }
        }),
        total: { applications: toNumber(total['applications']), byReason: toCounts(total['byReason']) },
    }
}
